import { PageRoutes } from "./historyGaming";

export const FOOTER_NAVIGATION = [
  {
    id: "home",
    path: PageRoutes.HomePage,
    title: "Home",
    icon: "icon-linear-home",
    iconActive: "icon-bold-home",
  },
  {
    id: "rank",
    title: "Rank",
    path: PageRoutes.Rank,
    icon: "icon-linear-ranking",
    iconActive: "icon-bold-ranking",
  },
  {
    id: "icon-button",
    iconActive: "icon-bold-arrow-down-3",
  },
  {
    id: "friends",
    path: PageRoutes.Friends,
    title: "Friends",
    icon: "icon-linear-profile-2user",
    iconActive: "icon-bold-profile-2user",
  },
  {
    id: "shop",
    path: PageRoutes.Shop,
    title: "Shop",
    icon: "icon-shopping-bag1",
    iconActive: "icon-bold-shopping-bag",
  },
];

export type FooterNavItem = {
  id: string;
  path: string;
  title: string;
  icon: string;
};

export const FOOTER_NAV_ITEMS = [
  {
    id: "home",
    path: PageRoutes.HomePage,
    title: "Home",
    icon: "icon-linear-home",
  },
  {
    id: "rank",
    title: "Rank",
    path: PageRoutes.Rank,
    icon: "icon-bold-ranking",
  },
  {
    id: "friends",
    path: PageRoutes.Friends,
    title: "Friends",
    icon: "icon-bold-friend",
  },
  {
    id: "shop",
    path: PageRoutes.Shop,
    title: "Store",
    icon: "icon-shop",
  },
  {
    id: "feed",
    path: PageRoutes.HomePage,
    title: "common_Feed",
    icon: "icon-game-bold",
  },
  {
    id: "video",
    path: PageRoutes.VideosVodacom,
    title: "common_Media",
    icon: "icon-bold-media",
  },
  {
    id: "store",
    path: PageRoutes.Store,
    title: "common_Store",
    icon: "icon-shop",
  },
  {
    id: "esports",
    title: "eSports",
    path: PageRoutes.Esports,
    icon: "icon-esports",
  },
] as const satisfies readonly FooterNavItem[];

const FOOTER_NAV_ITEM_MAP = Object.fromEntries(
  FOOTER_NAV_ITEMS.map((item) => [item.id, item])
) as Record<string, FooterNavItem>;

export const buildFooterNavigation = (itemIds: readonly string[]): FooterNavItem[] => {
  return itemIds
    .map((id) => FOOTER_NAV_ITEM_MAP[id])
    .filter((item): item is FooterNavItem => Boolean(item))
    .slice(0, 5);
};

export const FOOTER_NAVIGATION_WIDTH = 375;
export const FOOTER_NAVIGATION_HEIGHT = 72;
